import { useParams } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn } from '../components/ui/AnimatedSection';
import Calculator from '../features/pricing/Calculator';
import { useTranslation } from 'react-i18next';

export default function Ville() {
  const { t } = useTranslation();
  const { id } = useParams();
  
  // Format the city name beautifully (e.g. asnieres-sur-seine -> Asnières-sur-Seine)
  const formatCityName = (slug: string = '') => {
    return slug.split('-').map(word => {
      if (['sur', 'sous', 'aux', 'les', 'le', 'la', 'en'].includes(word.toLowerCase())) return word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('-');
  };

  const cityName = formatCityName(id);

  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      
      <main className="flex-grow">
        <PageHeader 
          title={t('ville.headerTitle', { cityName })} 
          subtitle={t('ville.headerSubtitle')}
          imagePath="/assets/luxury_haussmann.webp" 
        />

        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <FadeIn>
              <h2 className="text-3xl md:text-4xl font-serif text-black-deep mb-6">{t('ville.sectionTitle', { cityName })}</h2>
              <div className="w-16 h-1 bg-gold-400 mx-auto mb-8"></div>
              <p className="text-lg font-light text-gray-600 leading-relaxed mb-8">
                {t('ville.desc1', { cityName })}
              </p>
              <p className="text-lg font-light text-gray-600 leading-relaxed mb-12">
                {t('ville.desc2', { cityName })}
              </p>
            </FadeIn>
          </div>
        </section>

        <Calculator />
      </main>

      <Footer />
    </div>
  );
}
